export const CLICKED_SUBSCRIBE_CTA = 'Clicked Subscribe CTA';
export const SURF_CHECK_TREATMENT_VARIANT = 'surf_check';
export const ACCOUNT_BENEFITS_TREATMENT_VARIANT = 'account_benefits';
